import Vue from 'vue'
import { cloneDeep as _cloneDeep } from 'lodash'

Vue.set(Vue.prototype, '_cloneDeep', _cloneDeep)
